<template>
  <b-card>
    <b-row class="mb-3">
      <b-col sm="2" align-self="end">
        <label for="CPFContribuinte">CPF</label>
      </b-col>
      <b-col sm="2" align-self="start">
        <b-form-input
          id="CPFContribuinte"
          disabled
          v-model="responsavel.cpf"
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col sm="2" align-self="end">
        <label for="NomeContribuinte">Nome</label>
      </b-col>
      <b-col sm="6" align-self="start">
        <b-form-input
          id="NomeContribuinte"
          disabled
          v-model="responsavel.nome"
        ></b-form-input>
      </b-col>
    </b-row>

    <div v-if="cnpj.nome && cnpj.valor">
      <b-row class="mb-3">
        <b-col sm="2" align-self="end">
          <label for="CNPJEmpresa">CNPJ</label>
        </b-col>
        <b-col sm="3" align-self="start">
          <b-form-input id="CNPJEmpresa" disabled v-model="cnpj.valor"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col sm="2" align-self="end">
          <label for="NomeFantasia">Nome Fantasia</label>
        </b-col>
        <b-col sm="6" align-self="start">
          <b-form-input id="NomeFantasia" disabled v-model="cnpj.nome"></b-form-input>
        </b-col>
      </b-row>

      <div v-if="contribuinte.inscricaoMunicipal && exibirSelecaoISSQN">
          <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                  <label for="InscricaoMunicipal">Inscrição Municipal</label>
              </b-col>
              <b-col sm="2" align-self="start">
                  <b-form-input id="InscricaoMunicipal" disabled v-model="responsavel.inscricaoMunicipal">
                  </b-form-input>
              </b-col>
          </b-row>
      </div>      
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    responsavel: Object,
    cnpj: Object,
  },
};
</script>